import React, { useMemo } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Loader from './Loader';

interface SponsoredTradeProps {
  isRightPanelVisible: boolean;
}

const SponsoredTrade: React.FC<SponsoredTradeProps> = ({ isRightPanelVisible }) => {
  const { theme } = useTheme();
  
  // Memoize the Loader component to prevent re-renders
  const memoizedLoader = useMemo(() => (
    <Loader size="md" scale="0.75x" title="" subtitle="" />
  ), []);
  
  const opacityClass = theme === 'dark' ? 'opacity-80' : 'opacity-1';

  return (
    <div 
      className="absolute bottom-4 left-0 p-6 pt-1"
      style={{
        width: isRightPanelVisible ? 'calc(100% - 15px)' : '100%',
        marginRight: isRightPanelVisible ? '15px' : '0'
      }}
    >
      <span className={`text-xs text-gray-400 flex flex-col items-center p-5`}>
        <div className="flex items-center justify-center p-2">
          {/* Sponsored Loader - Left side of logo (always visible) */}
          <div className="mx-1 me-4 p-0">
            <div className="text-xs theme-text-quaternary pt-7">
              <div className="flex items-center justify-center h-full rounded-lg p-0">
                {memoizedLoader}
              </div>
            </div>
          </div>
          
          {/* Display SVG image based on right panel visibility */}
          {isRightPanelVisible ? (
            <img
              src="images/paul_d_white.svg"
              alt="PaulD"
              className={`w-full h-auto mx-auto ${opacityClass}`}
            />
          ) : (
            <img
              src="images/paul_d_white_1.svg"
              alt="PaulD"
              className={`w-full h-auto mx-auto ${opacityClass}`}
            />
          )}
        </div>
      </span>
    </div>
  );
};

export default SponsoredTrade;
